import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import AnimatedSelect from "../../../shared/AnimatedSelect";
import "../../../shared/AnimatedSelect.css";

const PartnerCategoryFilters = ({ filterValues = {}, partnerCategories = [], onFilterChange }) => {
  const [selectedCategory, setSelectedCategory] = useState(filterValues.partnerCategory != null ? filterValues.partnerCategory : "");

  // Keep local UI state in sync when parent provides prefilled values
  useEffect(() => {
    setSelectedCategory(filterValues.partnerCategory != null ? filterValues.partnerCategory : "");
  }, [filterValues.partnerCategory]);

  return (
    <>
      <Col className="custom_col">
        <AnimatedSelect
          value={filterValues.hasDone || "Include"}
          options={[
            { label: "Include", value: "Include" },
            { label: "Exclude", value: "Exclude" }
          ]}
          onChange={(value) => onFilterChange && onFilterChange("hasDone", value)}
        />
      </Col>
      <Col className="custom_col">
        <AnimatedSelect
          value={selectedCategory}
          options={[
            { label: "All Partners", value: "All" },
            ...partnerCategories.map((item) => ({
              label: item.name,
              value: item.id
            }))
          ]}
          onChange={(value) => {
            setSelectedCategory(value);
            onFilterChange && onFilterChange("partnerCategory", value);
          }}
        />
      </Col>      
    </>
  );
};

export default PartnerCategoryFilters;

